import React from "react";
import {PillButton} from "./PillButton";
import {Modal} from "./Modal";

interface ConfirmCancelModalProps {
    warningMessage: string | string[];
    warningMessageRenderer?: Function;
    headerText: string;
    cancel: React.MouseEventHandler<HTMLDivElement>;
    confirm: React.MouseEventHandler<HTMLDivElement>;
    cancelButtonText?: string;
    confirmButtonText: string;
}

export let ConfirmCancelModal = function (props: ConfirmCancelModalProps) {
    let modalBody = null;
    if (Array.isArray(props.warningMessage)) {
        let modalBodyMessages = [];
        for (let i = 0; i < props.warningMessage.length; i++) {
            let message = props.warningMessage[i];
            modalBodyMessages.push(
                <div key={i} className="confirm-cancel-modal-message">
                    {message}
                </div>
            )
        }
        modalBody = (
            <div className="confirm-cancel-modal-body">
                {modalBodyMessages}
            </div>
        )
    } else if (props.warningMessageRenderer) {
        modalBody = (
            <div className="confirm-cancel-modal-body">
                {props.warningMessageRenderer()}
            </div>
        )
    } else {
        modalBody = (
            <div className="confirm-cancel-modal-body">
                {props.warningMessage}
            </div>
        )
    }
    return (
        <Modal
            boxClass="confirm-cancel-modal"
            headerText={props.headerText}
            onClickCloseOption={props.cancel}
        >
            {modalBody}

            <div className="confirm-cancel-modal-options">
                <div className="confirm-cancel-modal-option">
                    <PillButton
                        onClick={props.confirm}
                        buttonClasses="solid-green-button confirm-cancel-modal-button confirm-cancel-modal-confirm-button"
                        buttonText={props.confirmButtonText}
                        buttonTextClasses="confirm-cancel-modal-button-text"
                    />
                </div>
                <div className="confirm-cancel-modal-option">
                    <PillButton
                        onClick={props.cancel as React.MouseEventHandler<HTMLDivElement>}
                        buttonClasses="green-border-button confirm-cancel-modal-button confirm-cancel-modal-cancel-button"
                        buttonText={props.cancelButtonText || "CANCEL"}
                        buttonTextClasses="confirm-cancel-modal-button-text"
                    />
                </div>
            </div>
        </Modal>
    );
};

